import { createContext, useContext, useState, useEffect } from 'react'
import api from '../config/api'

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  // Check if user is already logged in
  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const response = await fetch(`${api.baseUrl}${api.endpoints.protected}`, {
          credentials: 'include'
        })
        
        if (response.ok) {
          setUser({ role: 'admin' })
        }
      } catch (error) {
        console.error('Auth check failed:', error)
      } finally {
        setLoading(false)
      }
    }
    
    checkAuthStatus()
  }, [])

  const login = async (password) => {
    try {
      const response = await fetch(`${api.baseUrl}${api.endpoints.login}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ password })
      })

      if (!response.ok) throw new Error('Login failed')
      
      const data = await response.json()
      setUser({ role: 'admin' })
      return data
    } catch (error) {
      throw error
    }
  }

  const logout = async () => {
    try {
      await fetch(`${api.baseUrl}${api.endpoints.logout}`, {
        method: 'POST',
        credentials: 'include'
      })
      setUser(null)
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth must be used within AuthProvider')
  return context
} 